import TooltipEx from "@components/Tooltip";
import React from "react";
import styles from "src/pages/presenze/monitorWF/filtroRichiesteWF.module.css"
import classNames from "classnames";
import {UseFormGetValues, UseFormSetValue} from "react-hook-form";
import {MonitorWfForm} from "./monitorWF";
import {IconAsterisk, IconSquareCheckFilled, IconSquareFilled} from "@tabler/icons-react";

interface FiltroElaborateProps {
    setValue: UseFormSetValue<MonitorWfForm>,
    getValues: UseFormGetValues<MonitorWfForm>
    statiClassName: string,
}

export const FiltroElaborate: React.FC<FiltroElaborateProps> = ({setValue, getValues, statiClassName}) => {

    let selectAll = getValues('statiElaborato.selectAll');
    let elaborato = getValues('statiElaborato.ELABORATO');
    let nonElaborato = getValues('statiElaborato.NON_ELABORATO');

    return <div className="inline-flex items-center">Elaborate:&nbsp;
        <div className={`${styles.statiFilter} ${statiClassName}`}>
            <a key="selectAll" className={classNames(styles.stateContainer, styles.hoverClass, selectAll ? styles.selectedClass : '')}
               onClick={() => {
                   setValue('statiElaborato.selectAll', true)
                   setValue('statiElaborato.ELABORATO', false)
                   setValue('statiElaborato.NON_ELABORATO', false)
               }}>
                <IconAsterisk size={14}/>
            </a>
            <TooltipEx tooltip={`Elaborate`}>
                <button key="ELABORATO" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, elaborato ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('statiElaborato.selectAll', false)
                            setValue('statiElaborato.ELABORATO', true)
                            setValue('statiElaborato.NON_ELABORATO', false)
                        }}>
                    <IconSquareCheckFilled size={16}/>
                </button>
            </TooltipEx>
            <TooltipEx tooltip={`Non elaborate`}>
                <button key="NON_ELABORATO" type="button"
                        className={classNames(styles.stateContainer, styles.hoverClass, nonElaborato ? styles.selectedClass : '')}
                        onClick={() => {
                            setValue('statiElaborato.selectAll', false)
                            setValue('statiElaborato.ELABORATO', false)
                            setValue('statiElaborato.NON_ELABORATO', true)
                        }}>
                    <IconSquareFilled size={16}/>
                </button>
            </TooltipEx>
        </div>
    </div>
};
